import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;
const supabaseKey = process.env.VUE_APP_SUPABASE_KEY;

const supabase = createClient(supabaseUrl, supabaseKey);

async function getRandomMovieClip() {
  const { data, error } = await supabase
    .from("random_movies") 
    .select("*")
    .limit(1);

  if (error) {
    console.error("Error fetching movie clip:", error);
    return null;
  }

  return data[0]; 
}

async function getMovieList() {
  const { data, error } = await supabase
    .from("distinct_movies") 
    .select("*")

  if (error) {
    console.error("Error fetching movie clip:", error);
    return null;
  }

  return data; 
}

export { getRandomMovieClip,getMovieList };
